import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MedioPagoSelect } from 'sharedComponents/select'

const MediosDePagoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MEDIO' htmlFor='select-medioPago' md={4} size='sm' />
      <Col md={8}>
        <Field name='medioPago'>
          {({ field }) => <MedioPagoSelect {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-medioPago' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MediosDePagoFormGroup)
